"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.opcionesGeneralesFacturacionElectronicaDefecto = void 0;
exports.opcionesGeneralesFacturacionElectronicaDefecto = {
    fechaEmisorElectronico: 0,
    fechaInicioEnvioReportes: 0,
    fechasReportesEspecificos: "",
    resolucionDGI: "",
    envioRapidoCFE: false,
    regimenEspecial: "0",
    referenciaExoneracion: "",
    enviarAnalisisDeuda: false,
    textoDebajoAnalisisDeuda: "",
    textoMailRecordatorioPago: "",
    adendaDefectoVentas: "",
    adendaDefectoDevoluciones: "",
    adendaDefectoRecibos: "",
    nombreRespuestaMailAutoenviado: "",
    mailRespuestaMailAutoenviado: "",
    mailsCopiaEnvioAutomatico: [],
    imprimirNombreComercial: false,
    recibosElectronicos: true,
    textoEnvioMailCFE: "",
    textoEnvioMailCFECobranza: ""
};
